"use client"; // Ensure this is a client-side component in Next.js
import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react'; // Import Swiper and SwiperSlide
import 'swiper/css'; // Import Swiper styles
import { Autoplay } from 'swiper/modules'; // Import Autoplay module

import { useEffect, useState } from 'react'
import axios from "axios";

import { endPoints } from "../../Constants";
import { useTranslation } from 'react-i18next';

const Updates = () => {
   const { t,i18n } = useTranslation();
  const swiperRef = useRef(null);

  const [myUpdates, setUpdates] = useState([]);


  useEffect(() => {
    const token = localStorage.getItem('token');

    axios.get(`${endPoints.updated}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
      .then((res) => {
        setUpdates(res.data)
        // console.log("MyData========>", myUpdates);

      })
      .catch((err) => {
        console.error("Error fetching data:", err);
      });
  }, []);


  // Function to handle hover and pause autoplay
  const handleMouseEnter = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.autoplay.stop(); // Stop autoplay on hover
    }
  };

  // Function to handle mouse leave and resume autoplay
  const handleMouseLeave = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.autoplay.start(); // Start autoplay when hover ends
    }
  };



  return (
    <section className="lyt-section" id='impupd'>
      <div className="container">
        <div className="heading-wrapper justify-content-center">
          <div className="text-center">
            <h2 className="bs-heading typdblue mb-2" data-aos="fade-in" data-aos-delay="200">{t('updateTitle')}</h2>
            <p className="bs-para typgrey" data-aos="fade-in" data-aos-delay="300">{t('updateDesc')}</p>
          </div>
        </div>
      </div>

      <div
        className="bs-swiper typ-update"
        onMouseEnter={handleMouseEnter}  // Add mouse enter event
        onMouseLeave={handleMouseLeave}  // Add mouse leave event
      >
        {/* Swiper container for updates */}
        <Swiper
          ref={swiperRef} // Attach ref to Swiper
          speed={3000}
          spaceBetween={34} // Space between slides
          slidesPerView={1} // Display one slide at a time
          loop={true} // Infinite loop
          breakpoints={{
            360: {
              slidesPerView: 1.2, // 2 slides on medium screens
            },
            640: {
              slidesPerView: 2.5, // 2 slides on medium screens
            },
            1024: {
              slidesPerView: 3, // 3 slides on larger screens
            },
            1280: {
              slidesPerView: 3.5, // 3 slides on larger screens
            },
          }}
          autoplay={{
            delay: 0,
          }}
          modules={[Autoplay]} // Add Autoplay module to enable auto-sliding
          className="bs-updates-swiper"
        >

          {myUpdates.map((item, index) => {
            const { updateDate, updateText,updateTextMr } = item; // Destructure id, date, para
            const UpdateText = i18n.language === 'mr' ? updateTextMr : updateText;
             const formattedDate = new Intl.DateTimeFormat(i18n.language === 'mr' ? 'mr-IN' : 'en-IN', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              weekday: 'long'
            }).format(new Date(updateDate));
            return (
              <SwiperSlide key={index}>
                <div className="bs-updates-box">
                  <div className="box-content">
                    <div className="tag">{formattedDate}</div>
                    <div className="description">{UpdateText}</div>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}


          {/* <SwiperSlide>
            <div className="bs-updates-box">
              <div className="box-content">
                <div className="tag">August 10, 2025</div>
                <div className="description">
                  Exciting developments in the tech industry that will change the way we approach projects.
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="bs-updates-box">
              <div className="box-content">
                <div className="tag">September 15, 2025</div>
                <div className="description">
                  Stay tuned for new partnerships and collaborations in the real estate and construction sectors.
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="bs-updates-box">
              <div className="box-content">
                <div className="tag">September 15, 2025</div>
                <div className="description">
                  Stay tuned for new partnerships and collaborations in the real estate and construction sectors.
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="bs-updates-box">
              <div className="box-content">
                <div className="tag">September 15, 2025</div>
                <div className="description">
                  Stay tuned for new partnerships and collaborations in the real estate and construction sectors.
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="bs-updates-box">
              <div className="box-content">
                <div className="tag">September 15, 2025</div>
                <div className="description">
                  Stay tuned for new partnerships and collaborations in the real estate and construction sectors.
                </div>
              </div>
            </div>
          </SwiperSlide> */}

          {/* You can add more slides here */}
        </Swiper>
      </div>
    </section>
  );
};

export default Updates;
